import { useU3402Context } from '../U3402Context';
import { NS } from '../U3402';
import { U3402_LU_CODE, luHandleAppiError } from '../U3402Service';
import U340xKpiStandaloneContainer from '../../u340xKpiShared/components/U340xKpiStandaloneContainer';

function U3402StandaloneScreen() {
  const { initLU } = useU3402Context();

  return (
    <U340xKpiStandaloneContainer
      logicalUnitCode={U3402_LU_CODE}
      nameSpace={NS}
      initLU={initLU}
      luHandleAppiError={luHandleAppiError}
    />
  );
}

export default U3402StandaloneScreen;
